import { useEffect, useState } from 'react';
import {
  closeLoader,
  errorModalOpen,
  isElementVisible,
  openLoader,
  RootState,
} from '@msc-b2c/shared-utils';
import { handleKeyDown } from '@msc-b2c/shared-utils/keyboardUtils';
import PaymentSubmit from '../paymentbox/components/PaymentSubmit/PaymentSubmit';
import { PaymentButtonProps } from '@msc-b2c/interfaces/types';
import { useDispatch, useSelector } from 'react-redux';
import { useAppleOrGooglePay } from './hooks/useAppleOrGooglePay';

const PaymentButton = ({
  merchantId,
  gpayMerchantId,
  datatransPaymentButtonUrl,
  termsLabel,
  merchantName,
  options,
  payment,
  paymentType,
}: PaymentButtonProps) => {
  const dispatch = useDispatch();
  const [areTermsAgreed, setAreTermsAgreed] = useState(false);
  const userEmailInput = useSelector((state: RootState) => state.myAreaCart?.loggedUserEmailInput);

  const {
    payButton,
    paymentLoading,
    error: errorMsg,
  } = useAppleOrGooglePay({
    merchantId,
    gpayMerchantId,
    datatransPaymentButtonUrl,
    merchantName,
    options,
    payment,
    paymentType,
  });

  useEffect(() => {
    paymentLoading ? openLoader('.loader') : closeLoader('.loader');
  }, [paymentLoading]);

  useEffect(() => {
    if (errorMsg) {
      dispatch(errorModalOpen(true));
      if (errorMsg && errorMsg.trim().length > 0) {
        setAreTermsAgreed(false);
      }
    }
  }, [errorMsg]);

  const handleTermsClick = () => setAreTermsAgreed((prevTermsState) => !prevTermsState);

  return !paymentLoading ? (
    <PaymentSubmit
      id={'payBtn-' + paymentType}
      terms={termsLabel}
      onCheck={handleTermsClick}
      checked={areTermsAgreed}
    >
      <div
        className={
          !areTermsAgreed ||
          (!userEmailInput && isElementVisible('.cmp-sidesummary__email-section'))
            ? 'disabled'
            : ''
        }
        ref={payButton}
        onKeyDown={(e) =>
          handleKeyDown(
            e,
            () => (e.target as HTMLElement).click(),
            [],
            areTermsAgreed &&
              !(!userEmailInput && isElementVisible('.cmp-sidesummary__email-section'))
          )
        }
      />
    </PaymentSubmit>
  ) : null;
};

export default PaymentButton;
